import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BTGSEOService } from '@btgdigital/cosmos/seo';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  private meta = inject(Meta);
  public BTGSEOService = inject(BTGSEOService);
  
  setCustomTag(name: string, content: any, tag?: string, property?: boolean) {
    if (property) {
      this.meta.updateTag(
        { property: tag ? `${tag}:${name}` : name,
          content: content },
          tag ? `property='${tag}:${name}'` : `property='${name}'`
      );
    } else {
      this.meta.updateTag(
        { name: tag ? `${tag}:${name}` : name,
          content: content },
          tag ? `name='${tag}:${name}'` : `name='${name}'`
      );
    }
  }
}